var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"filtered-asset-name-root"},_vm._l((_vm.filteredAssetList),function(item,index){return _c('div',{key:index,on:{"click":function($event){return _vm.updateSelectedAssetName(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }